/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  EndFleetEventSeriesBody,
  FleetCalendar200,
  FleetCalendarParams,
  FleetEventCreateInput,
  FleetEventExtended,
  FleetEventOccurrenceState,
  FleetEventParams,
  FleetEventUpdateInput,
  FleetEventsList,
  FleetEventsParams,
  SchemaValidationErrorResponse,
  SkipFleetEventOccurrenceBody,
  StandardError,
  UpdateFleetEventOccurrenceBody
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Fleet Calendar
 */
export const fleetCalendar = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetCalendarParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetCalendar200>(
      {url: `/fleets/${fleetSlug}/calendar`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetCalendarQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetCalendarParams>,) => {
    return [
    'fleets',fleetSlug,'calendar', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetCalendarQueryOptions = <TData = Awaited<ReturnType<typeof fleetCalendar>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetCalendarParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetCalendar>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetCalendarQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetCalendar>>> = ({ signal }) => fleetCalendar(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetCalendar>>, TError, TData>
}

export type FleetCalendarQueryResult = NonNullable<Awaited<ReturnType<typeof fleetCalendar>>>
export type FleetCalendarQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Calendar
 */

export function useFleetCalendar<TData = Awaited<ReturnType<typeof fleetCalendar>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetCalendarParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetCalendar>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetCalendarQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Fleet Event
 */
export const createFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetEventCreateInput: MaybeRefOrGetter<FleetEventCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetEventCreateInput = toValue(fleetEventCreateInput);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventCreateInput, signal
    },
      );
    }




export const getCreateFleetEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetEvent>>, TError,{fleetSlug: string;data: FleetEventCreateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetEvent>>, TError,{fleetSlug: string;data: FleetEventCreateInput}, TContext> => {

const mutationKey = ['createFleetEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetEvent>>, {fleetSlug: string;data: FleetEventCreateInput}> = (props) => {
          const {fleetSlug,data} = props ?? {};

          return  createFleetEvent(fleetSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetEvent>>>
    export type CreateFleetEventMutationBody = FleetEventCreateInput
    export type CreateFleetEventMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Create Fleet Event
 */
export const useCreateFleetEvent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetEvent>>, TError,{fleetSlug: string;data: FleetEventCreateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetEvent>>,
        TError,
        {fleetSlug: string;data: FleetEventCreateInput},
        TContext
      > => {
      return useMutation(getCreateFleetEventMutationOptions(options), queryClient);
    }
    /**
 * @summary List Fleet Events
 */
export const fleetEvents = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetEventsParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetEventsList>(
      {url: `/fleets/${fleetSlug}/events`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetEventsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetEventsParams>,) => {
    return [
    'fleets',fleetSlug,'events', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetEventsQueryOptions = <TData = Awaited<ReturnType<typeof fleetEvents>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetEventsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetEvents>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetEventsQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetEvents>>> = ({ signal }) => fleetEvents(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetEvents>>, TError, TData>
}

export type FleetEventsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetEvents>>>
export type FleetEventsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary List Fleet Events
 */

export function useFleetEvents<TData = Awaited<ReturnType<typeof fleetEvents>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetEventsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetEvents>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetEventsQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Archive Fleet Event
 */
export const destroyFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended | void>(
      {url: `/fleets/${fleetSlug}/events/${slug}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext> => {

const mutationKey = ['destroyFleetEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetEvent>>, {fleetSlug: string;slug: string}> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  destroyFleetEvent(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetEvent>>>

    export type DestroyFleetEventMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Archive Fleet Event
 */
export const useDestroyFleetEvent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetEvent>>,
        TError,
        {fleetSlug: string;slug: string},
        TContext
      > => {
      return useMutation(getDestroyFleetEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Show Fleet Event
 */
export const fleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetEventParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
params = toValue(params);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetEventQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetEventParams>,) => {
    return [
    'fleets',fleetSlug,'events',slug, ...(params ? [params] : [])
    ] as const;
    }


export const getFleetEventQueryOptions = <TData = Awaited<ReturnType<typeof fleetEvent>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetEventParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetEvent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetEventQueryKey(fleetSlug,slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetEvent>>> = ({ signal }) => fleetEvent(fleetSlug,slug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetEvent>>, TError, TData>
}

export type FleetEventQueryResult = NonNullable<Awaited<ReturnType<typeof fleetEvent>>>
export type FleetEventQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show Fleet Event
 */

export function useFleetEvent<TData = Awaited<ReturnType<typeof fleetEvent>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetEventParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetEvent>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetEventQueryOptions(fleetSlug,slug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Fleet Event
 */
export const updateFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    fleetEventUpdateInput: MaybeRefOrGetter<FleetEventUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
fleetEventUpdateInput = toValue(fleetEventUpdateInput);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventUpdateInput, signal
    },
      );
    }




export const getUpdateFleetEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEvent>>, TError,{fleetSlug: string;slug: string;data: FleetEventUpdateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetEvent>>, TError,{fleetSlug: string;slug: string;data: FleetEventUpdateInput}, TContext> => {

const mutationKey = ['updateFleetEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetEvent>>, {fleetSlug: string;slug: string;data: FleetEventUpdateInput}> = (props) => {
          const {fleetSlug,slug,data} = props ?? {};

          return  updateFleetEvent(fleetSlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetEvent>>>
    export type UpdateFleetEventMutationBody = FleetEventUpdateInput
    export type UpdateFleetEventMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update Fleet Event
 */
export const useUpdateFleetEvent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEvent>>, TError,{fleetSlug: string;slug: string;data: FleetEventUpdateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetEvent>>,
        TError,
        {fleetSlug: string;slug: string;data: FleetEventUpdateInput},
        TContext
      > => {
      return useMutation(getUpdateFleetEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Cancel Fleet Event
 */
export const cancelFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/cancel`, method: 'PUT', signal
    },
      );
    }




export const getCancelFleetEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext> => {

const mutationKey = ['cancelFleetEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelFleetEvent>>, {fleetSlug: string;slug: string}> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  cancelFleetEvent(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof cancelFleetEvent>>>

    export type CancelFleetEventMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Cancel Fleet Event
 */
export const useCancelFleetEvent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof cancelFleetEvent>>,
        TError,
        {fleetSlug: string;slug: string},
        TContext
      > => {
      return useMutation(getCancelFleetEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Complete Fleet Event
 */
export const completeFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/complete`, method: 'PUT', signal
    },
      );
    }




export const getCompleteFleetEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext> => {

const mutationKey = ['completeFleetEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeFleetEvent>>, {fleetSlug: string;slug: string}> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  completeFleetEvent(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof completeFleetEvent>>>

    export type CompleteFleetEventMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Complete Fleet Event
 */
export const useCompleteFleetEvent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof completeFleetEvent>>,
        TError,
        {fleetSlug: string;slug: string},
        TContext
      > => {
      return useMutation(getCompleteFleetEventMutationOptions(options), queryClient);
    }
    /**
 * @summary End a recurring event series from a given date
 */
export const endFleetEventSeries = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    endFleetEventSeriesBody: MaybeRefOrGetter<EndFleetEventSeriesBody>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
endFleetEventSeriesBody = toValue(endFleetEventSeriesBody);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/end-series`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: endFleetEventSeriesBody, signal
    },
      );
    }




export const getEndFleetEventSeriesMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endFleetEventSeries>>, TError,{fleetSlug: string;slug: string;data: EndFleetEventSeriesBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof endFleetEventSeries>>, TError,{fleetSlug: string;slug: string;data: EndFleetEventSeriesBody}, TContext> => {

const mutationKey = ['endFleetEventSeries'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof endFleetEventSeries>>, {fleetSlug: string;slug: string;data: EndFleetEventSeriesBody}> = (props) => {
          const {fleetSlug,slug,data} = props ?? {};

          return  endFleetEventSeries(fleetSlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EndFleetEventSeriesMutationResult = NonNullable<Awaited<ReturnType<typeof endFleetEventSeries>>>
    export type EndFleetEventSeriesMutationBody = EndFleetEventSeriesBody
    export type EndFleetEventSeriesMutationError = ErrorType<SchemaValidationErrorResponse>

    /**
 * @summary End a recurring event series from a given date
 */
export const useEndFleetEventSeries = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endFleetEventSeries>>, TError,{fleetSlug: string;slug: string;data: EndFleetEventSeriesBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof endFleetEventSeries>>,
        TError,
        {fleetSlug: string;slug: string;data: EndFleetEventSeriesBody},
        TContext
      > => {
      return useMutation(getEndFleetEventSeriesMutationOptions(options), queryClient);
    }
    /**
 * @summary Lock Signups
 */
export const lockFleetEventSignups = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/lock-signups`, method: 'PUT', signal
    },
      );
    }




export const getLockFleetEventSignupsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lockFleetEventSignups>>, TError,{fleetSlug: string;slug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof lockFleetEventSignups>>, TError,{fleetSlug: string;slug: string}, TContext> => {

const mutationKey = ['lockFleetEventSignups'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lockFleetEventSignups>>, {fleetSlug: string;slug: string}> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  lockFleetEventSignups(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LockFleetEventSignupsMutationResult = NonNullable<Awaited<ReturnType<typeof lockFleetEventSignups>>>

    export type LockFleetEventSignupsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Lock Signups
 */
export const useLockFleetEventSignups = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lockFleetEventSignups>>, TError,{fleetSlug: string;slug: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof lockFleetEventSignups>>,
        TError,
        {fleetSlug: string;slug: string},
        TContext
      > => {
      return useMutation(getLockFleetEventSignupsMutationOptions(options), queryClient);
    }
    /**
 * @summary Publish Fleet Event
 */
export const publishFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/publish`, method: 'PUT', signal
    },
      );
    }




export const getPublishFleetEventMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof publishFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext> => {

const mutationKey = ['publishFleetEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishFleetEvent>>, {fleetSlug: string;slug: string}> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  publishFleetEvent(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof publishFleetEvent>>>

    export type PublishFleetEventMutationError = ErrorType<StandardError>

    /**
 * @summary Publish Fleet Event
 */
export const usePublishFleetEvent = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof publishFleetEvent>>,
        TError,
        {fleetSlug: string;slug: string},
        TContext
      > => {
      return useMutation(getPublishFleetEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Skip a specific occurrence of a recurring event
 */
export const skipFleetEventOccurrence = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    skipFleetEventOccurrenceBody: MaybeRefOrGetter<SkipFleetEventOccurrenceBody>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
skipFleetEventOccurrenceBody = toValue(skipFleetEventOccurrenceBody);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/skip-occurrence`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: skipFleetEventOccurrenceBody, signal
    },
      );
    }




export const getSkipFleetEventOccurrenceMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipFleetEventOccurrence>>, TError,{fleetSlug: string;slug: string;data: SkipFleetEventOccurrenceBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof skipFleetEventOccurrence>>, TError,{fleetSlug: string;slug: string;data: SkipFleetEventOccurrenceBody}, TContext> => {

const mutationKey = ['skipFleetEventOccurrence'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skipFleetEventOccurrence>>, {fleetSlug: string;slug: string;data: SkipFleetEventOccurrenceBody}> = (props) => {
          const {fleetSlug,slug,data} = props ?? {};

          return  skipFleetEventOccurrence(fleetSlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkipFleetEventOccurrenceMutationResult = NonNullable<Awaited<ReturnType<typeof skipFleetEventOccurrence>>>
    export type SkipFleetEventOccurrenceMutationBody = SkipFleetEventOccurrenceBody
    export type SkipFleetEventOccurrenceMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Skip a specific occurrence of a recurring event
 */
export const useSkipFleetEventOccurrence = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipFleetEventOccurrence>>, TError,{fleetSlug: string;slug: string;data: SkipFleetEventOccurrenceBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof skipFleetEventOccurrence>>,
        TError,
        {fleetSlug: string;slug: string;data: SkipFleetEventOccurrenceBody},
        TContext
      > => {
      return useMutation(getSkipFleetEventOccurrenceMutationOptions(options), queryClient);
    }
    /**
 * @summary Start Fleet Event
 */
export const startFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/start`, method: 'PUT', signal
    },
      );
    }




export const getStartFleetEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof startFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext> => {

const mutationKey = ['startFleetEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startFleetEvent>>, {fleetSlug: string;slug: string}> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  startFleetEvent(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof startFleetEvent>>>

    export type StartFleetEventMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Start Fleet Event
 */
export const useStartFleetEvent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof startFleetEvent>>,
        TError,
        {fleetSlug: string;slug: string},
        TContext
      > => {
      return useMutation(getStartFleetEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Sync event to Discord
 */
export const syncFleetEventToDiscord = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/sync-to-discord`, method: 'POST', signal
    },
      );
    }




export const getSyncFleetEventToDiscordMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncFleetEventToDiscord>>, TError,{fleetSlug: string;slug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof syncFleetEventToDiscord>>, TError,{fleetSlug: string;slug: string}, TContext> => {

const mutationKey = ['syncFleetEventToDiscord'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncFleetEventToDiscord>>, {fleetSlug: string;slug: string}> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  syncFleetEventToDiscord(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncFleetEventToDiscordMutationResult = NonNullable<Awaited<ReturnType<typeof syncFleetEventToDiscord>>>

    export type SyncFleetEventToDiscordMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Sync event to Discord
 */
export const useSyncFleetEventToDiscord = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncFleetEventToDiscord>>, TError,{fleetSlug: string;slug: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof syncFleetEventToDiscord>>,
        TError,
        {fleetSlug: string;slug: string},
        TContext
      > => {
      return useMutation(getSyncFleetEventToDiscordMutationOptions(options), queryClient);
    }
    /**
 * @summary Unarchive Fleet Event
 */
export const unarchiveFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/unarchive`, method: 'PUT', signal
    },
      );
    }




export const getUnarchiveFleetEventMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unarchiveFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext> => {

const mutationKey = ['unarchiveFleetEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unarchiveFleetEvent>>, {fleetSlug: string;slug: string}> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  unarchiveFleetEvent(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnarchiveFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof unarchiveFleetEvent>>>

    export type UnarchiveFleetEventMutationError = ErrorType<StandardError>

    /**
 * @summary Unarchive Fleet Event
 */
export const useUnarchiveFleetEvent = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveFleetEvent>>, TError,{fleetSlug: string;slug: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unarchiveFleetEvent>>,
        TError,
        {fleetSlug: string;slug: string},
        TContext
      > => {
      return useMutation(getUnarchiveFleetEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Unlock Signups
 */
export const unlockFleetEventSignups = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/unlock-signups`, method: 'PUT', signal
    },
      );
    }




export const getUnlockFleetEventSignupsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockFleetEventSignups>>, TError,{fleetSlug: string;slug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unlockFleetEventSignups>>, TError,{fleetSlug: string;slug: string}, TContext> => {

const mutationKey = ['unlockFleetEventSignups'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlockFleetEventSignups>>, {fleetSlug: string;slug: string}> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  unlockFleetEventSignups(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlockFleetEventSignupsMutationResult = NonNullable<Awaited<ReturnType<typeof unlockFleetEventSignups>>>

    export type UnlockFleetEventSignupsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Unlock Signups
 */
export const useUnlockFleetEventSignups = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockFleetEventSignups>>, TError,{fleetSlug: string;slug: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unlockFleetEventSignups>>,
        TError,
        {fleetSlug: string;slug: string},
        TContext
      > => {
      return useMutation(getUnlockFleetEventSignupsMutationOptions(options), queryClient);
    }
    /**
 * @summary Override fields on a single occurrence
 */
export const updateFleetEventOccurrence = (
    fleetSlug: MaybeRefOrGetter<string | null>,
    slug: MaybeRefOrGetter<string | null>,
    updateFleetEventOccurrenceBody: MaybeRefOrGetter<UpdateFleetEventOccurrenceBody>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
updateFleetEventOccurrenceBody = toValue(updateFleetEventOccurrenceBody);

      return axiosClient<FleetEventOccurrenceState>(
      {url: `/fleets/${fleetSlug}/events/${slug}/update-occurrence`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateFleetEventOccurrenceBody, signal
    },
      );
    }




export const getUpdateFleetEventOccurrenceMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventOccurrence>>, TError,{fleetSlug: string | null;slug: string | null;data: UpdateFleetEventOccurrenceBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventOccurrence>>, TError,{fleetSlug: string | null;slug: string | null;data: UpdateFleetEventOccurrenceBody}, TContext> => {

const mutationKey = ['updateFleetEventOccurrence'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetEventOccurrence>>, {fleetSlug: string | null;slug: string | null;data: UpdateFleetEventOccurrenceBody}> = (props) => {
          const {fleetSlug,slug,data} = props ?? {};

          return  updateFleetEventOccurrence(fleetSlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetEventOccurrenceMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetEventOccurrence>>>
    export type UpdateFleetEventOccurrenceMutationBody = UpdateFleetEventOccurrenceBody
    export type UpdateFleetEventOccurrenceMutationError = ErrorType<SchemaValidationErrorResponse>

    /**
 * @summary Override fields on a single occurrence
 */
export const useUpdateFleetEventOccurrence = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventOccurrence>>, TError,{fleetSlug: string | null;slug: string | null;data: UpdateFleetEventOccurrenceBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetEventOccurrence>>,
        TError,
        {fleetSlug: string | null;slug: string | null;data: UpdateFleetEventOccurrenceBody},
        TContext
      > => {
      return useMutation(getUpdateFleetEventOccurrenceMutationOptions(options), queryClient);
    }
